module.exports = __webpack_public_path__ + "img/ic_upload_icons@2x.05bda946.png";